import { useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'

const ASSET_URL = '/static/office_presence.js?v=20260901-1'

export default function OfficePresenceHeartbeat() {
  const { user } = useAuth()

  useEffect(() => {
    if (!user) return
    const state = window as typeof window & {
      __alexOfficePresenceHeartbeatLoaded?: boolean
      __alexOfficePresenceAssetRequested?: boolean
    }
    if (state.__alexOfficePresenceHeartbeatLoaded || state.__alexOfficePresenceAssetRequested) return

    state.__alexOfficePresenceAssetRequested = true
    const existing = document.querySelector<HTMLScriptElement>('script[data-office-presence="1"]')
    if (existing) return

    const script = document.createElement('script')
    script.src = ASSET_URL
    script.async = true
    script.dataset.officePresence = '1'
    script.addEventListener('error', () => {
      state.__alexOfficePresenceAssetRequested = false
    }, { once: true })
    document.head.appendChild(script)
  }, [user])

  return null
}
